import React from "react";

const CustomerAdvertisingAgentAgreement = () => {
  return (
    <section
      id="customer_advertising_agent_agreement"
      className="ico_about_section section_space section_decoration bg-white"
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <h4 className="title_text text-dark mb-3">
              Becoming a Customer Advertising Agent Agreement
            </h4>
            <p className="text-dark fw-semibold opacity-75">
              <strong>
                TopCoin UK Ltd - Customer Advertising M Agent &amp; Senior
                Advertising Agent Agreement
              </strong>
            </p>

            <h5 className="title_text text-dark mt-4">
              Agent Participation Notice
            </h5>
            <p className="text-dark opacity-75 mb-2">
              This Agreement sets out the terms for members who wish to
              participate as a <strong>Customer Advertising M Agent</strong> or{" "}
              <strong>Senior Advertising Agent</strong> within the TopCoin UK
              platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Participation as an Agent is separate from ordinary customer
              membership. Becoming a customer, collecting TopCoin or reaching a
              particular TopCoin balance does{" "}
              <strong>not automatically make a member an Agent</strong>.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Members wishing to become Agents must apply through the TopCoin UK
              platform and accept the applicable Agent terms.
            </p>

            <h5 className="title_text text-dark">1. Platform Purpose</h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd operates a loyalty and promotional platform
              connecting customers with participating businesses.
            </p>
            <p className="text-dark opacity-75 mb-4">
              The Customer Advertising Agent programme supports the expansion of
              the TopCoin UK customer network by allowing approved Agents to
              introduce new customers to the platform.
            </p>

            <h5 className="title_text text-dark">2. Customer Membership</h5>
            <p className="text-dark opacity-75 mb-2">
              Individuals may join the TopCoin UK platform as customers subject
              to the applicable membership terms.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Customer membership and Agent participation are separate.
            </p>
            <p className="text-dark opacity-75 mb-4">
              A customer who wishes to participate in the Advertising Agent
              programme must apply for the appropriate Agent status and receive
              approval from TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">
              3. Customer Advertising M Agent Role
            </h5>
            <p className="text-dark opacity-75 mb-2">
              An eligible TopCoin UK member may apply to become a{" "}
              <strong>Customer Advertising M Agent</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Customer Advertising M Agents help expand the platform by:
            </p>
            <ul className="text-dark opacity-75 mb-2">
              <li>introducing new customers to TopCoin UK;</li>
              <li>promoting awareness of the TopCoin UK platform; and</li>
              <li>
                supporting responsible growth of the TopCoin UK customer
                community.
              </li>
            </ul>
            <p className="text-dark opacity-75 mb-4">
              Agents must use only authorised TopCoin UK referral links,
              promotional materials and platform facilities where required.
            </p>

            <h5 className="title_text text-dark">4. Customer Referrals</h5>
            <p className="text-dark opacity-75 mb-2">
              Approved Customer Advertising M Agents may introduce new customers
              to the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Where an Agent introduces a customer using the appropriate Agent
              referral process, the platform may record the Agent as the
              introducing Agent.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The referred customer becomes a customer of the{" "}
              <strong>TopCoin UK platform</strong> and is subject to the same
              applicable customer terms and programme rules as other customers.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Customers do not become the property of the introducing Agent, and
              an Agent does not acquire ownership or exclusive rights over
              referred customers.
            </p>

            <h5 className="title_text text-dark">
              5. Customers Do Not Participate as Agents Automatically
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Ordinary customers are not required to refer other customers.
            </p>
            <p className="text-dark opacity-75 mb-2">
              A customer does not become an Advertising Agent simply by joining
              TopCoin UK, shopping through the platform, collecting TopCoin,
              reaching a particular TopCoin balance, or referring someone
              informally.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Participation in the official Advertising Agent programme requires
              the applicable <strong>Agent application and approval</strong>.
            </p>

            <h5 className="title_text text-dark">
              6. Senior Advertising Agent Status
            </h5>
            <p className="text-dark opacity-75 mb-2">
              A Customer Advertising M Agent may become eligible to apply for or
              be considered for <strong>Senior Advertising Agent</strong> status
              after introducing a minimum of{" "}
              <strong>1,000 active customers</strong> to the TopCoin UK
              platform.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Meeting this threshold does not automatically guarantee Senior
              Advertising Agent status.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Eligibility remains subject to verification, programme
              requirements and approval by TopCoin UK Ltd.
            </p>

            <h5 className="title_text text-dark">
              7. Senior Advertising Agent Role
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Senior Advertising Agents may support the development and
              responsible expansion of the TopCoin UK customer network.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Their role may include supporting and guiding Customer Advertising
              M Agents, promoting awareness of the TopCoin UK platform,
              encouraging responsible customer introductions, and supporting the
              standards and objectives of the Advertising Agent programme.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Senior Advertising Agents remain subject to TopCoin UK policies
              and applicable Agent terms.
            </p>

            <h5 className="title_text text-dark">
              8. Retail Agent Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Eligible members may separately apply to participate in the Retail
              Agent programme.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agent roles may include <strong>Retail M Agent</strong> and{" "}
              <strong>Senior Retail Agent</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Retail Agents focus on introducing eligible businesses rather than
              customers.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Retail Agent participation may be governed by separate terms and
              agreements.
            </p>

            <h5 className="title_text text-dark">9. Agent Conduct</h5>
            <p className="text-dark opacity-75 mb-2">
              Agents must promote TopCoin UK accurately, responsibly and
              professionally.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents must not make false or misleading statements about TopCoin
              UK; make unauthorised promises on behalf of TopCoin UK Ltd;
              present themselves as employees unless separately employed; use
              misleading, aggressive or inappropriate promotional practices;
              misuse customer information or platform data; misrepresent the
              TopCoin loyalty programme; or use TopCoin UK branding without
              appropriate authorisation.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Serious or repeated breaches may result in restriction, suspension
              or termination of Agent participation.
            </p>

            <h5 className="title_text text-dark">
              10. Independent Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Unless otherwise agreed in writing, Agents participate
              independently.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Nothing in this Agreement creates an employment relationship,
              partnership, joint venture or authority for an Agent to legally
              bind TopCoin UK Ltd.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents must not enter into agreements or make commitments on
              behalf of TopCoin UK Ltd without written authority.
            </p>

            <h5 className="title_text text-dark">
              11. Customer Data and Privacy
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Agents must handle personal information responsibly and in
              accordance with applicable data protection requirements and
              TopCoin UK policies.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents must not collect, retain, disclose or use customer
              information for unauthorised purposes.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Customer information held within the TopCoin UK platform remains
              subject to the platform's applicable privacy and data-protection
              policies.
            </p>

            <h5 className="title_text text-dark">
              12. Brand and Intellectual Property
            </h5>
            <p className="text-dark opacity-75 mb-2">
              The TopCoin UK name, branding, logos, platform systems, software,
              content, technology and other intellectual property remain the
              property of TopCoin UK Ltd or their respective rights holders.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents may use authorised TopCoin UK materials only for approved
              Agent activities and in accordance with TopCoin UK brand
              guidelines.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents may not copy, modify, reproduce or misuse protected TopCoin
              UK materials without permission.
            </p>

            <h5 className="title_text text-dark">
              13. Confidential Information
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Non-public information relating to TopCoin UK's systems,
              technology, business operations, Agent programme or internal
              processes must be treated as confidential where applicable.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents must not disclose or use confidential information for
              unauthorised purposes.
            </p>

            <h5 className="title_text text-dark">
              14. International Participation
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Agents operating outside the United Kingdom must comply with
              applicable laws and regulations in the jurisdictions in which they
              operate.
            </p>
            <p className="text-dark opacity-75 mb-4">
              International participation may be subject to additional
              eligibility requirements, restrictions or programme terms.
            </p>

            <h5 className="title_text text-dark">
              15. Responsibility for Agent Conduct
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Agents are responsible for their own statements, communications
              and promotional activities.
            </p>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may take appropriate action where an Agent acts
              outside the authority granted under the Agent Programme or
              breaches applicable terms or policies.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Nothing in this Agreement excludes or limits liability where doing
              so would be unlawful.
            </p>

            <h5 className="title_text text-dark">
              16. Platform Rules and Changes
            </h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may update the Agent Programme, platform
              functionality, eligibility requirements and operational rules
              where reasonably necessary for legal, regulatory, security,
              operational or business reasons.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Material changes will be communicated in accordance with the
              applicable platform terms.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Continued participation may be subject to acceptance of updated
              terms where required.
            </p>

            <h5 className="title_text text-dark">
              17. Suspension and Termination
            </h5>
            <p className="text-dark opacity-75 mb-2">
              TopCoin UK Ltd may restrict, suspend or terminate Agent
              participation in accordance with this Agreement and applicable
              platform policies, including where necessary to protect customers,
              participating businesses, the platform or the TopCoin UK brand.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Agents may also cease participating in the Agent Programme in
              accordance with the applicable termination procedure.
            </p>

            <h5 className="title_text text-dark">
              18. TopCoin UK Platform Network
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Customers introduced by Agents become participants in the{" "}
              <strong>TopCoin UK platform network</strong>.
            </p>
            <p className="text-dark opacity-75 mb-2">
              The introducing Agent does not acquire ownership, control or
              exclusive rights over those customers.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Customers maintain their own relationship with TopCoin UK and
              participate in accordance with the applicable customer terms and
              platform rules.
            </p>

            <h5 className="title_text text-dark">
              19. No Lifetime Rights or Ownership of Customers
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Participation as a Customer Advertising M Agent or Senior
              Advertising Agent does not grant an Agent lifetime rights,
              ownership or control over customers they introduce.
            </p>
            <p className="text-dark opacity-75 mb-2">
              Agents act as introducers to the TopCoin UK platform and are not
              responsible for a customer's ongoing participation after the
              introduction, except where specific responsibilities are expressly
              stated in the Agent Programme terms.
            </p>
            <p className="text-dark opacity-75 mb-2">
              If an Agent's participation ends, customers previously introduced
              by that Agent remain customers of the TopCoin UK platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Any rights or obligations surviving termination will be determined
              by this Agreement and the applicable TopCoin UK terms.
            </p>

            <h5 className="title_text text-dark">20. Governing Law</h5>
            <p className="text-dark opacity-75 mb-2">
              This Agreement is governed by the laws of{" "}
              <strong>England and Wales</strong>.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Any disputes relating to this Agreement will be handled in
              accordance with the dispute-resolution and jurisdiction provisions
              contained in the applicable TopCoin UK terms.
            </p>

            <p className="text-dark opacity-75 mt-4 text-center">
              <strong>TopCoin UK Ltd</strong>
              <br />
              Advertising &amp; Loyalty Platform
            </p>

            <hr className="mt-5 mb-5" />

            <h5 className="title_text text-dark">
              Website Summary: Become a TopCoin UK Advertising Agent
            </h5>
            <p className="text-dark opacity-75 mb-2">
              Help expand the TopCoin UK community by introducing new customers
              to the platform.
            </p>
            <p className="text-dark opacity-75 mb-4">
              Joining TopCoin UK as a customer does not automatically make you
              an Agent. If you would like to refer customers as part of the
              official Agent Programme, apply to become a Customer Advertising M
              Agent.
            </p>
            <p className="text-dark fw-bold mb-4 border border-2 border-dark p-3 text-center">
              JOIN TOPCOIN UK &gt; APPLY TO BECOME AN AGENT &gt; GET APPROVED
              &gt; START REFERRING CUSTOMERS
            </p>
            <p className="text-dark opacity-75 mb-4">
              <strong>Review note:</strong> Because this is intended as a UK
              commercial agreement, the final published version should be
              reviewed by a qualified UK solicitor, particularly for the
              independent-agent relationship, referral structure, consumer
              protection, data protection and termination provisions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerAdvertisingAgentAgreement;
